import React from "react";
import "./card-info-docs.scss";
import Text from "../../../../shared/comfama-ui/components/text";

type InfoDocType = {
    tituloGeneral: string;
    content: [
        {
            key: number;
            urlImage: string;
            title: string;
            description: string;
            idContentful: string;
        }
    ];
    getValues: any;
    infoType: string;
};

const CardInfoDocs = (props: InfoDocType) => {
    const { tituloGeneral, content, getValues, infoType } = props;
    const isD = getValues("appModality") === "D";
    const isI = getValues("appModality") === "I";
    const urlImageToolTip  = content.find((item) => item.description === "")?.urlImage ;

    return (
        <div className="card-info-docs">
            {tituloGeneral ? 
            <Text className="card-info-docs__title" as="h3">
                {tituloGeneral}
            </Text> : null}
            {content && content.map((item, index) => {
                const isFinishedLaborText = item.idContentful === "7M3sQwqbJfZQMBGD3zxJsG"
                if (item.title === "icon tool tip") return;
                if(index >= 1 && infoType === "interestQuestion") return;
                if(index === 0 && infoType === "attachments") return;
                //Disabled SISE info file Information
                if(item.idContentful === "MxJzQS6gtQhQ5ivAMAt6n") return;
                return (
                    <div className="card-info-docs__content" key={item.key}>
                        <img src={item.urlImage} alt="imagen" />
                        <Text className="card-info-docs__content-text" as="p">
                            {isI && isFinishedLaborText ? "Certificado de cesación de ingresos" : item.title}
                           {item.description && <div className="card-info-docs__tooltip">
                                <img src={urlImageToolTip} alt="imagen" />
                                <span className="card-info-docs__tooltip-text">
                                 <p>{isI && isFinishedLaborText ? "Certificado de cesación de ingresos" : item.title}</p>
                                 {isI && isFinishedLaborText? "Para personas independientes" : isD && isFinishedLaborText ?"Para personas dependientes" : item.description}
                               {item.idContentful === "MxJzQS6gtQhQ5ivAMAt6n" &&  
                                 <a href="https://personas.serviciodeempleo.gov.co/login.aspx" target="_blank" rel="noreferrer">Ingresar</a>
                                 } 
                                </span>
                            </div>} 
                        </Text>
                    </div>
                );
            })}
        </div>
    );
};

export default CardInfoDocs;
